const dropdownStyles = {
  control: (styles) => {
    return {
      ...styles,
      borderRadius: 20,
      fontSize: "14px",
      "&:hover": { },
      boxShadow: '#E5E5E5',
      borderColor: '#E5E5E5'
    };
  },
  placeholder: (styles) => {
    return {
      ...styles,
      fontSize: "14px",
      color: "#595C5C",
      marginLeft: '8px'
    };
  },
  option: (styles, state) => {
    return {
      ...styles,
      fontSize: "14px",
      color: "#000000",
      backgroundColor: state.isFocused ? '#f2f2f2' : styles.backgroundColor,
      "&:hover": { backgroundColor: '#f2f2f2' }
    };
  },
  menu: (provided) => {
    return {
      ...provided,
      fontSize: "14px",
      zIndex: 9999,
      color: "#000000"
    };
  },
  multiValue: (styles) => (
    {
      ...styles,
      fontSize: "14px",
      borderRadius: 70,
      color: "#595C5C",
      backgroundColor: "#ffffff",
      paddingRight: "5px",
      paddingLeft: "5px",
      border: '1px solid #E5E5E5'
    }
  ),
  multiValueLabel: (styles) => ({ ...styles, fontSize: "14px", color: "#595C5C", whiteSpace: "normal" }),
  valueContainer: (styles) => ({ ...styles, fontSize: "14px", paddingLeft: "5px" }),
  multiValueRemove: (styles) => {
    return { ...styles, color: "#595C5C", ":hover": { color: '#808080' } };
  }
};

const conceptDropdownStyles = {
  control: (styles) => {
    return {
      ...styles,
      fontSize: "14px",
      "&:hover": { },
      boxShadow: '#E5E5E5',
      borderColor: '#E5E5E5',
      borderRadius: '4px'
    };
  },
  placeholder: (styles) => {
    return {
      ...styles,
      fontSize: "14px",
      color: "#595C5C",
      marginLeft: '8px'
    };
  },
  option: (styles, state) => {
    return {
      ...styles,
      fontSize: "14px",
      color: "#000000",
      backgroundColor: state.isFocused || state.isSelected ? '#f2f2f2' : '#ffffff',
      "&:hover": { backgroundColor: '#f2f2f2' }
    };
  },
  menu: (provided) => {
    return {
      ...provided,
      fontSize: "14px",
      zIndex: 9999,
      color: "#000000"
    };
  },
  multiValue: (styles) => (
    {
      ...styles,
      fontSize: "14px",
      borderRadius: 70,
      color: "#595C5C",
      backgroundColor: "#ffffff",
      paddingRight: "5px",
      paddingLeft: "5px",
      border: '1px solid #E5E5E5'
    }
  ),
  multiValueLabel: (styles) => ({ ...styles, fontSize: "14px", color: "#595C5C", whiteSpace: "normal" }),
  valueContainer: (styles) => ({ ...styles, fontSize: "14px", paddingLeft: "5px" }),
  multiValueRemove: (styles) => {
    return { ...styles, color: "#595C5C", ":hover": { color: '#808080' } };
  }
};

export { dropdownStyles, conceptDropdownStyles };
